import { useEffect } from 'react'
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom'
import ProtectedRoute from './protected-route'
import { useStoreActions } from '@store'

// Components
import Dashboard from './dashboard'
import StandardReport from './standard-report'
import CreateStandardReportPage from './standard-report/create'
import StandardReportDetails from './standard-report/[id]'
import Organization from './organization'
import OrganizationAdd from './organization/add'
import OrganizationDetails from './organization/[id]'
import OrganizationEdit from './organization/editprofile/[id]'
import StandardReportOrganization from './standard-report-organization'
import StandardReportSent from './sent'
import StandardReportSentDetail from './sent/[id]'
import AdminUser from './admin-user'
import SignIn from './sign-in'
import SentChart from './sent-chart'
import ExportPdfPage from './export-pdf'
import ExportPdfComparisonPage from './export-pdf-comparison'

export default function AdminsRoute() {
	const { path } = useRouteMatch()
	const setAppType = useStoreActions(a => a.appModel.setAppType)

	useEffect(() => {
		setAppType('admin')
	}, [setAppType])

	return (
		<Switch>
			<ProtectedRoute exact path={path}>
				<Dashboard />
			</ProtectedRoute>

			<ProtectedRoute path={`${path}/organization/editprofile/:id`}>
				<OrganizationEdit />
			</ProtectedRoute>

			<ProtectedRoute exact path={`${path}/organization/add`}>
				<OrganizationAdd />
			</ProtectedRoute>

			<ProtectedRoute path={`${path}/organization/:id`}>
				<OrganizationDetails />
			</ProtectedRoute>

			<ProtectedRoute exact path={`${path}/organization`}>
				<Organization />
			</ProtectedRoute>

			<ProtectedRoute path={`${path}/standard-report/create`}>
				<CreateStandardReportPage />
			</ProtectedRoute>

			<ProtectedRoute path={`${path}/standard-report/:id`}>
				<StandardReportDetails />
			</ProtectedRoute>

			<ProtectedRoute exact path={`${path}/standard-report`}>
				<StandardReport />
			</ProtectedRoute>

			<ProtectedRoute exact path={`${path}/admin-user`}>
				<AdminUser />
			</ProtectedRoute>

			<ProtectedRoute exact path={`${path}/standard-report-organization`}>
				<StandardReportOrganization />
			</ProtectedRoute>

			<ProtectedRoute exact path={`${path}/sent`}>
				<StandardReportSent />
			</ProtectedRoute>

			<ProtectedRoute path={`${path}/sent/:id`}>
				<StandardReportSentDetail />
			</ProtectedRoute>

			<ProtectedRoute exact path={`${path}/sent-chart`}>
				<SentChart />
			</ProtectedRoute>

			<ProtectedRoute exact path={`${path}/export-pdf`}>
				<ExportPdfPage />
			</ProtectedRoute>

			<ProtectedRoute exact path={`${path}/export-pdf-comparison`}>
				<ExportPdfComparisonPage />
			</ProtectedRoute>

			<Route path={`${path}/sign-in`} component={SignIn} />

			<Redirect from={`${path}/*`} to={path} />
		</Switch>
	)
}
